import { AuthenticationMethodsFido2Schema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/fido2/model';
import { updateAuthenticationMethodPolicyConfig } from 'projects/angular-clarity/src/app/stores/client/graph/authentication-methods-policies/actions';

export function remediate(_tenant: string, policy: any, schema: AuthenticationMethodsFido2Schema) {
    const updatedPolicy: any = {
        ...policy,
        state: schema.properties.state.const,
    };

    // Strip OData response annotations (e.g. "includeTargets@odata.context") — response metadata, not writable.
    for (const key of Object.keys(updatedPolicy)) {
        if (key.includes('@odata.') && key !== '@odata.type') {
            delete updatedPolicy[key];
        }
    }

    if (schema.properties.state.const === 'disabled') {
        // Strip allowedPasskeyProfiles from includeTargets — profile IDs may not exist on all tenants.
        if (Array.isArray(updatedPolicy.includeTargets)) {
            updatedPolicy.includeTargets = updatedPolicy.includeTargets.map(
                ({ allowedPasskeyProfiles: _, ...rest }: any) => rest,
            );
        }
        return updateAuthenticationMethodPolicyConfig({
            _tenant,
            policy: updatedPolicy,
        });
    }

    updatedPolicy.isSelfServiceRegistrationAllowed = schema.properties.isSelfServiceRegistrationAllowed?.const;

    updatedPolicy.isAttestationEnforced = schema.properties.isAttestationEnforced?.const;

    const keyRestrictionsSchema = schema.properties?.keyRestrictions;
    if (keyRestrictionsSchema) {
        updatedPolicy.keyRestrictions = {
            isEnforced: keyRestrictionsSchema.properties.isEnforced.const,
        };

        if (keyRestrictionsSchema.properties.isEnforced.const === true) {
            updatedPolicy.keyRestrictions.enforcementType = keyRestrictionsSchema.properties.enforcementType?.const;
            updatedPolicy.keyRestrictions.aaGuids = keyRestrictionsSchema.properties.aaGuids?.const || [];
        }
    }

    // Sync the default passkey profile's keyRestrictions/attestationEnforcement to match global settings.
    // Graph API rejects PATCH when global keyRestrictions.enforcementType doesn't match the default profile's.
    updatedPolicy.passkeyProfiles = updatedPolicy.passkeyProfiles?.map((profile: any) => {
        const isDefaultProfile = profile.id === updatedPolicy.defaultPasskeyProfile;

        if (isDefaultProfile) {
            return {
                ...profile,
                attestationEnforcement: schema.properties.isAttestationEnforced?.const
                    ? 'registrationOnly'
                    : 'disabled',
                keyRestrictions: {
                    isEnforced: schema.properties?.keyRestrictions?.properties.isEnforced.const,
                    enforcementType: schema.properties?.keyRestrictions?.properties.enforcementType?.const,
                    aaGuids: schema.properties?.keyRestrictions?.properties.aaGuids?.const || [],
                },
            };
        } else {
            return profile;
        }
    });

    if (schema.properties?.includeTargets?.maxItems > 0) {
        updatedPolicy.includeTargets = schema.properties.includeTargets.items.oneOf.map((target) => ({
            id: target.properties.id.const,
            targetType: target.properties.targetType.const,
        }));
    } else {
        updatedPolicy.includeTargets = [];
    }

    if (schema.properties?.excludeTargets?.maxItems > 0) {
        updatedPolicy.excludeTargets = schema.properties.excludeTargets.items.oneOf.map((target) => ({
            id: target.properties.id.const,
            targetType: target.properties.targetType.const,
        }));
    } else {
        updatedPolicy.excludeTargets = [];
    }

    return updateAuthenticationMethodPolicyConfig({
        _tenant,
        policy: updatedPolicy,
    });
}
